import React from 'react';
import { Box, CheckCircleIcon, Text } from '@razorpay/blade/components';

interface PanNameViewProps {
  title: string;
  value: string;
}

const PanNameView = ({ title, value }: PanNameViewProps) => {
  return (
    <Box backgroundColor="surface.background.gray.moderate" padding={['spacing.5', 'spacing.4']}>
      <Box display="flex" alignItems="center" gap="spacing.4">
        <CheckCircleIcon color="interactive.icon.positive.normal" size="xlarge" />
        <Box display="flex" flexDirection="column" gap="spacing.1">
          <Text variant="caption" size="small" color="surface.text.gray.muted">
            {title}
          </Text>
          <Text weight="medium" color="surface.text.gray.subtle">
            {value}
          </Text>
        </Box>
      </Box>
    </Box>
  );
};

export { PanNameView };
